import { api } from './config';
import { ApiResponse } from '../types';
import { brandFeedbackApi } from './feedbackFactory';

export const brandApi = {
  getProfile: () => api.get<ApiResponse>('/profile'),

  updateProfile: (data: Record<string, any>) =>
    api.put<ApiResponse>('/profile', data),

  getSampleRequests: (params?: Record<string, any>) =>
    api.get<ApiResponse>('/brand/sample-requests', { params }),

  getSampleRequestDetail: (id: string | number) =>
    api.get<ApiResponse>(`/brand/sample-requests/${id}`),

  updateSampleRequest: (id: string | number, data: Record<string, any>) =>
    api.put<ApiResponse>(`/brand/sample-requests/${id}`, data),

  // Feedback (using factory pattern)
  ...brandFeedbackApi,
};
